// Hub topbar location selector.
//
// Visible only when the signed-in Pro has membership at 2+ locations
// (per useProLocations()). Single-location Pros (the common case) see
// nothing — no selector, no UI clutter, and zero awareness that
// other locations exist. This is the access-driven gate.
//
// Renders a compact native <select> styled to the Hub's image-black /
// image-pink palette. Switching writes through to localStorage via
// LocationProvider; pages re-fetch on the next render because their
// queries key on activeLocationId.

import { useProLocations } from '@/lib/proLocations';
import { useActiveLocationId } from '@/lib/locationContext';

export function LocationSelector() {
  const { data: locations } = useProLocations();
  const { activeLocationId, setActiveLocationId } = useActiveLocationId();

  // Hidden when fewer than 2 locations — single-location Pros never see it.
  if (!locations || locations.length < 2) return null;

  return (
    <select
      value={activeLocationId ?? ''}
      onChange={(e) => setActiveLocationId(e.target.value)}
      aria-label="Active location"
      className="bg-image-black/60 border border-image-pink/40 text-white text-[11px] font-medium rounded px-2 py-1 focus:border-image-pink focus:outline-none cursor-pointer hover:border-image-pink/70 transition-colors"
    >
      {locations.map((l) => {
        // Strip the redundant "IMAGE Studios — " prefix so the
        // selector trigger fits in a tight topbar.
        const label = l.display_name.replace(/^IMAGE Studios\s*[—–-]\s*/i, '');
        const suffix = l.suite_number != null ? ` · #${l.suite_number}` : '';
        return (
          <option key={l.location_id} value={l.location_id}>
            {label}{suffix}
          </option>
        );
      })}
    </select>
  );
}
